// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1ixsq","resendInfoText":"OnGoingPaymentBox_resendInfoText__1BKPJ"};